/* eslint-disable react-hooks/exhaustive-deps */
import { gql, useLazyQuery } from '@apollo/client';
import {
	Box,
	Button,
	Flex,
	FormControl,
	FormHelperText,
	FormLabel,
	InputGroup,
	InputRightElement,
	Tag,
	TagCloseButton,
	TagLabel,
	Text,
	useDisclosure,
} from '@chakra-ui/react';
import { faList } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Field, useFormikContext } from 'formik';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import EwsSummaryCompanyListModal from './ews-summary-company-list-modal';
import useStore from '../../../store';
import c from '../../../constant';

const Q_COMPANY = gql`
	query get($id: String!) {
		getCompanyByCompanyId(id: $id) {
			id
			name
			nameKhmer
			logo
			url
			type
			latestUpdateBranchAt
		}
	}
`;

export default function EwsSummaryCompanyFormField({ name = null, label = null, formNameCompanyType = null, required = false }) {
	const { t } = useTranslation();
	const { currentLang: lang } = useStore((state) => state.currentLang);
	const { values } = useFormikContext();
	const { isOpen, onOpen, onClose } = useDisclosure();
	const [fetchCompanyDetail, { data }] = useLazyQuery(Q_COMPANY);

	useEffect(() => values[name] && load(), [values[name]]);

	function load() {
		const variables = { id: values[name] };
		fetchCompanyDetail({ variables });
	}

	return (
		<>
			<Field name={name}>
				{({ meta, form }) => (
					<Box mb="4">
						<FormControl id={name}>
							<FormLabel>
								{t(label)}
								{required && <span style={{ color: 'red' }}>*</span>}
							</FormLabel>
							<InputGroup size="md">
								<Flex alignItems="center" w="100%" borderRadius={c.borderRadius} h="48px" border="1px solid #CBD5E0">
									{data?.getCompanyByCompanyId && values[name] ? (
										<Tag
											size="lg"
											ml="2px"
											borderRadius={c.borderRadius}
											variant="solid"
											colorScheme="green"
											w="calc(100% - 75px)"
											h="42px"
										>
											<TagLabel w="100%" fontSize={18} pt="8px" pb="8px">
												{lang === 'kh'
													? data?.getCompanyByCompanyId?.nameKhmer || data?.getCompanyByCompanyId?.name
													: data?.getCompanyByCompanyId?.name || data?.getCompanyByCompanyId?.nameKhmer}
											</TagLabel>
											<TagCloseButton onClick={() => form?.setFieldValue(name, null)} />
										</Tag>
									) : (
										<Text fontSize="medium" fontWeight="medium" ml={4} mr={4}>
											{t('Company')}
										</Text>
									)}
								</Flex>
								<InputRightElement width="4.5rem">
									<Button
										variant="solid"
										mr="4px"
										mt="8px"
										h="42px"
										borderRadius={c.borderRadius}
										leftIcon={
											<FontAwesomeIcon
												icon={faList}
												style={{
													cursor: 'pointer',
													fontSize: 16,
												}}
											/>
										}
										onClick={onOpen}
									>
										{t('List')}
									</Button>
								</InputRightElement>
							</InputGroup>
							<>
								{meta.touched && meta.error && (
									<FormHelperText id={`error-message-${name}`} color="red.400" fontSize="12px">
										{t(label)} {t('is')} {t(meta.error)}
									</FormHelperText>
								)}
							</>
						</FormControl>
						<>
							{isOpen && (
								<EwsSummaryCompanyListModal
									companyType={values[formNameCompanyType]}
									onClose={onClose}
									onCallback={(e) => form?.setFieldValue(name, e?.id)}
								/>
							)}
						</>
					</Box>
				)}
			</Field>
		</>
	);
}
